import React from 'react';
import MainLayout from '../components/MainLayout';
import { ManagerApprovalInbox } from '../components/ManagerApprovalInbox';
import { CheckSquare } from 'lucide-react';

const ManagerApprovals = () => (
  <MainLayout>
    <div data-testid="manager-approvals-page" className="space-y-5">
      <div>
        <h1 className="text-xl font-bold text-slate-900 flex items-center gap-2">
          <CheckSquare className="w-5 h-5 text-[#0052FF]" /> My Team Approvals
        </h1>
        <p className="text-xs text-slate-500 mt-0.5">
          Advance, Claim Sheet, Reimbursement, Regularization, Leave, OT, Shift and Comp-Off
          requests from employees mapped to you. Approve, reject or send back with remarks.
        </p>
      </div>
      <ManagerApprovalInbox />
    </div>
  </MainLayout>
);

export default ManagerApprovals;
